"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hamMenu = () => {
    const hamButton = document.getElementById('sp_ham_button');
    const hamMenu = document.getElementById('sp_ham_menu');
    const hamAnchorButtons = hamMenu.querySelectorAll('a');
    hamButton.addEventListener('click', (e) => {
        e.preventDefault();
        hamButton.classList.toggle('is_open');
        hamMenu.classList.toggle('is_open');
    });
    // console.log(hamAnchorButtons);
    hamAnchorButtons.forEach((anchorButton) => {
        const anchorElem = anchorButton;
        anchorElem.addEventListener('click', () => {
            if (anchorElem.href.includes('#')) {
                hamButton.classList.remove('is_open');
                hamMenu.classList.remove('is_open');
            }
        });
    });
};
exports.default = hamMenu;
